(function () {
    const bookToc = {
        vPort: 'screen-sm', // default responsive break point
        init: function init() {
            bookToc.controls();
        },
        controls: function controls() {
            $(document).on(bookToc.vPort + '-on', function () {
                bookToc.reOrder();
            });
            $(document).on(bookToc.vPort + '-off', function () {
                bookToc.unDo();
            });
        },
        reOrder: function order() {
            const coverImage = '#coverImage';
            const bookDetails = '#bookDetails';
            if ($(coverImage).length) {
                $(coverImage).insertBefore('#cover-image-anchor');
            }
            if ($(bookDetails).length) {
                $(bookDetails).insertAfter('#book-details-anchor');
            }
        },
        unDo: function undo() {
            $('#bookDetails').prependTo('.toc-flex-right');
            $('#coverImage').prependTo('.toc-flex-right');
        },
    };
    UX.bookToc = bookToc;
    document.addEventListener('DOMContentLoaded', function () {
        if (document.querySelector('main .book-toc')) {
            UX.bookToc.init();
        }
    });
})();
